import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { ContactPage } from './pages/ContactPage';
import { ThankYouPage } from './pages/ThankYouPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<HomePage data-id="element-3" />} data-id="element-2" />
        <Route path="/contacto" element={<ContactPage data-id="element-5" />} data-id="element-4" />
        <Route path="/gracias" element={<ThankYouPage data-id="element-7" />} data-id="element-6" />
      </Routes>
    </BrowserRouter>;
}